import IcDelete from '@deliveryhero/pd-cookbook/components/Icons/IcDelete';
import IcEdit from '@deliveryhero/pd-cookbook/components/Icons/IcEdit';
import IcShow from '@deliveryhero/pd-cookbook/components/Icons/IcShow';
import { ListItemIcon, MenuItem } from '@mui/material';

export interface AllowanceListingActionMenuProps {
  handleEdit?: () => void;
  handleDelete?: () => void;
  handleView?: () => void;
}

export const AllowanceListingActionMenu = ({
  handleEdit,
  handleDelete,
  handleView
}: AllowanceListingActionMenuProps) => {
  return (
    <>
      {handleEdit && (
        <MenuItem onClick={handleEdit}>
          <ListItemIcon>
            <IcEdit />
          </ListItemIcon>
          Edit
        </MenuItem>
      )}
      {handleDelete && (
        <MenuItem onClick={handleDelete}>
          <ListItemIcon>
            <IcDelete />
          </ListItemIcon>
          Delete
        </MenuItem>
      )}
      {handleView && (
        <MenuItem onClick={handleView}>
          <ListItemIcon>
            <IcShow />
          </ListItemIcon>
          View
        </MenuItem>
      )}
    </>
  );
};
